import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthUser } from '../../context/AuthUserContext';
import { generarReciboCarrito } from '../Carrito/reciboCarrito';

import './MiCuenta.css';

const API      = 'https://centrocomunicar.com/api-comunicar/endpoints/auth.php';
const API_PAGA = 'https://centrocomunicar.com/api-comunicar/endpoints/recursos_paga.php';
const WA_BASE  = 'https://wa.me/51940686868';           // ← cambia al número real
const HOME_URL = 'https://centrocomunicar.com';    // ← URL de inicio
const AULA_URL = 'https://centrocomunicar.com/virtual/login/index.php';

/* ── Icons ── */
const IconUser     = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2"/></svg>);
const IconDownload = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><polyline points="7 10 12 15 17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconCart     = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 6h18M16 10a4 4 0 01-8 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconStar     = () => (<svg viewBox="0 0 24 24" fill="#f59e0b" width="14" height="14"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>);
const IconBook     = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconWhatsapp = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconLogout   = () => (<svg viewBox="0 0 24 24" fill="none" width="17" height="17"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><polyline points="16 17 21 12 16 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconEdit     = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconShield   = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconArrow    = () => (<svg viewBox="0 0 20 20" fill="none" width="14" height="14"><path d="M4 10h12M11 6l5 4-5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconCheck    = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><polyline points="20 6 9 17 4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconSpinner  = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18" style={{animation:'spin .7s linear infinite'}}><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeOpacity=".25"/><path d="M12 2a10 10 0 0110 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconAula     = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><rect x="2" y="3" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M8 21h8M12 17v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconHome     = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><polyline points="9 22 9 12 15 12 15 22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconBox      = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><polyline points="3.27 6.96 12 12.01 20.73 6.96" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><line x1="12" y1="22.08" x2="12" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconPdf      = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M14 2v6h6M9 13h6M9 17h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconLink     = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);

/* ── Constantes ── */
const NIVEL_COLORS = { explorador:'gris', comunicador:'verde', especialista:'dorado', experto:'negro' };
const NIVEL_LABELS = { explorador:'Explorador', comunicador:'Comunicador', especialista:'Especialista', experto:'Experto' };
const TIPO_ICON    = { pdf:'📄', word:'📝', ppt:'📊', excel:'📈', zip:'📦', video:'🎥', imagen:'🖼', otro:'📎' };

/* ── TABS — Mis recursos entre Descargas y Compras ── */
const TABS = [
  { id:'resumen',     label:'Resumen',      Icon:IconUser     },
  { id:'descargas',   label:'Descargas',    Icon:IconDownload },
  { id:'recursos',    label:'Mis recursos', Icon:IconBox      },
  { id:'compras',     label:'Compras',      Icon:IconCart     },
  { id:'puntos',      label:'Mis puntos',   Icon:IconStar     },
  { id:'formaciones', label:'Formaciones',  Icon:IconBook     },
  { id:'perfil',      label:'Mi perfil',    Icon:IconEdit     },
];

/* ════════════════════════════════════════ */
export default function MiCuenta() {
  const { usuario, logout, authHeader, actualizarUsuario } = useAuthUser();
  const navigate = useNavigate();
  const [tab, setTab] = useState('resumen');

  /* Datos por tab */
  const [descargas,   setDescargas]   = useState([]);
  const [misRecursos, setMisRecursos] = useState([]);
  const [compras,     setCompras]     = useState([]);
  const [puntos,      setPuntos]      = useState(null);
  const [formaciones, setFormaciones] = useState([]);
  const [loadingTab,  setLoadingTab]  = useState(false);

  const [descargando,    setDescargando]    = useState({});
  const [archivosModal,  setArchivosModal]  = useState(null); // { titulo, archivos[] }

  const descargarRecurso = async (recursoId, titulo) => {
    setDescargando(d => ({...d, [recursoId]: true}));
    try {
      const tkn = localStorage.getItem('com_token');
      const r = await fetch(
        `https://centrocomunicar.com/api-comunicar/endpoints/descarga_paga.php?action=generar_tokens_multi&recurso_id=${recursoId}`,
        { headers: { 'Authorization': `Bearer ${tkn}` } }
      );
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      if (j.archivos.length === 1) {
        // Un solo archivo — descargar directo
        window.open(j.archivos[0].url, '_blank');
      } else {
        // Múltiples archivos — mostrar modal
        setArchivosModal({ titulo, archivos: j.archivos });
      }
    } catch(err) {
      showToast('Error al generar descarga: ' + err.message, 'error');
    } finally {
      setDescargando(d => ({...d, [recursoId]: false}));
    }
  };

  /* Perfil edición */
  const [editForm,   setEditForm]   = useState({});
  const [guardando,  setGuardando]  = useState(false);
  const [guardadoOk, setGuardadoOk] = useState(false);
  const [editError,  setEditError]  = useState('');

  /* Toast */
  const [toast, setToast] = useState(null);
  const showToast = (msg, tipo='ok') => {
    setToast({msg,tipo});
    setTimeout(()=>setToast(null), 3000);
  };

  /* ── Cargar datos según tab ── */
  useEffect(() => {
    const fetchTab = async () => {
      setLoadingTab(true);
      try {
        if (tab === 'descargas' && descargas.length === 0) {
          const r = await fetch(`${API}?action=mis_descargas`, { headers: authHeader() });
          const j = await r.json();
          if (j.success) setDescargas(j.data || []);
        }
        if (tab === 'recursos' && misRecursos.length === 0) {
          const r = await fetch(`${API_PAGA}?action=mis_recursos`, { headers: authHeader() });
          const j = await r.json();
          if (j.success) setMisRecursos(j.data || []);
        }
        if (tab === 'compras' && compras.length === 0) {
            const r = await fetch(`${API_PAGA}?action=mis_compras`, { headers: authHeader() });

          const j = await r.json();
          if (j.success) setCompras(j.data || []);
        }
      
      
        if (tab === 'puntos') {
          const [r1, r2] = await Promise.all([
            fetch(`${API_PAGA}?action=mis_puntos`,          { headers: authHeader() }),
            fetch(`${API_PAGA}?action=historial_puntos`,    { headers: authHeader() }),
          ]);


            const [j1, j2] = await Promise.all([r1.json(), r2.json()]);
            setPuntos({
              puntos_disponibles: j1.success ? (j1.data?.puntos_disponibles || 0) : 0,
              puntos_totales:     j1.success ? (j1.data?.puntos_totales     || 0) : 0,
              puntos_canjeados:   j1.success ? (j1.data?.puntos_canjeados   || 0) : 0,
              nivel:              j1.success ? (j1.data?.nivel              || 'explorador') : 'explorador',
              por_vencer:         j1.success ? (j1.data?.por_vencer         || 0) : 0,
              historial:          j2.success ? (j2.data || []) : [],
            });
          }
        if (tab === 'formaciones' && formaciones.length === 0) {
          const r = await fetch(`${API}?action=mis_formaciones`, { headers: authHeader() });
          const j = await r.json();
          if (j.success) setFormaciones(j.data || []);
        }
        if (tab === 'perfil') {
          setEditForm({
            nombre:          usuario?.nombre          || '',
            apellido:        usuario?.apellido        || '',
            telefono:        usuario?.telefono        || '',
            whatsapp:        usuario?.whatsapp        || '',
            perfil:          usuario?.perfil          || 'otro',
            acepta_whatsapp: usuario?.acepta_whatsapp || false,
          });
        }
      } catch(e) {}
      finally { setLoadingTab(false); }
    };
    fetchTab();
  }, [tab]);

  /* ── Guardar perfil ── */
  const guardarPerfil = async e => {
    e.preventDefault();
    setGuardando(true); setEditError('');
    try {
      const r = await fetch(`${API}?action=actualizar`, {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(editForm),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      actualizarUsuario(j.data);
      setGuardadoOk(true);
      showToast('Perfil actualizado correctamente');
      setTimeout(()=>setGuardadoOk(false), 3000);
    } catch(err) { setEditError(err.message); }
    finally { setGuardando(false); }
  };

  /* ── Logout → redirige a HOME_URL ── */
  const handleLogout = async () => {
    await logout();
    window.location.href = HOME_URL;
  };

  /* ── WhatsApp especial (usuario registrado) ── */
  const waLink = () => {
    const nombre = encodeURIComponent(usuario?.nombre || '');
    const email  = encodeURIComponent(usuario?.email  || '');
    return `${WA_BASE}?text=Hola%2C%20soy%20${nombre}%20(${email})%2C%20usuario%20registrado%20en%20Comunicar.%20Necesito%20ayuda%20con%3A`;
  };

  if (!usuario) return null;

  const iniciales = ((usuario.nombre||'')[0] + (usuario.apellido||'')[0] || 'U').toUpperCase();

  return (
    <div className="mc-page">

      {toast && (
        <div className={`mc-toast mc-toast--${toast.tipo}`}>
          <IconCheck/> {toast.msg}
        </div>
      )}

      {/* ── NAV ── */}
      <nav className="mc-nav">
        <Link to="/" className="mc-nav__logo">
          <img src="/images/logo_centro.png" alt="Comunicar" style={{height:40,width:'auto',display:'block'}}/>
        </Link>
        <div className="mc-nav__right">
          <a href={waLink()} target="_blank" rel="noopener noreferrer" className="mc-nav__wa">
            <IconWhatsapp/> Soporte WhatsApp
          </a>
          {/* Botón inicio */}
          <a href={HOME_URL} className="mc-nav__home">
            <IconHome/> Inicio
          </a>
          {/* Botón cerrar sesión */}
          <button className="mc-nav__logout" onClick={handleLogout}>
            <IconLogout/> Cerrar sesión
          </button>
        </div>
      </nav>

      <div className="mc-layout">

        {/* ── SIDEBAR ── */}
        <aside className="mc-sidebar">

          {/* Avatar */}
          <div className="mc-profile-card">
            <div className="mc-avatar">{iniciales}</div>
            <div>
              <h3>{usuario.nombre} {usuario.apellido}</h3>
              <p>{usuario.email}</p>
              {!usuario.email_verificado && (
                <span
                  className="mc-unverified"
                  style={{cursor:'pointer'}}
                  onClick={async()=>{
                    const r = await fetch(`${API}?action=perfil`, {headers:authHeader()});
                    const j = await r.json();
                    if(j.success) actualizarUsuario(j.data);
                  }}
                  title="Haz clic para verificar si ya confirmaste"
                >
                  Email sin verificar — clic para actualizar
                </span>
              )}
            </div>
          </div>

          {/* Nivel de puntos */}
        {/* Nivel de puntos */}
        {puntos && (
            <div className={`mc-nivel mc-nivel--${NIVEL_COLORS[puntos.nivel]||'gris'}`}>
              <div className="mc-nivel__icon"><IconShield/></div>
              <div>
                <strong>{NIVEL_LABELS[puntos.nivel] || 'Explorador'}</strong>
                <span>{puntos.puntos_disponibles || 0} puntos</span>
              </div>
            </div>
          )}

          {/* Tabs nav */}
          <nav className="mc-tabs-nav">
            {TABS.map(({id,label,Icon})=>(
              <button
                key={id}
                className={`mc-tab-btn ${tab===id?'mc-tab-btn--active':''}`}
                onClick={()=>setTab(id)}
              >
                <Icon/> {label}
              </button>
            ))}
          </nav>

          {/* WhatsApp especial */}
          <a href={waLink()} target="_blank" rel="noopener noreferrer" className="mc-wa-btn">
            <IconWhatsapp/>
            <div>
              <strong>Soporte directo</strong>
              <span>Como usuario registrado</span>
            </div>
            <IconArrow/>
          </a>

          {/* Cerrar sesión sidebar */}
          <button className="mc-sidebar__logout" onClick={handleLogout}>
            <IconLogout/> Cerrar sesión
          </button>

        </aside>

        {/* ── MAIN CONTENT ── */}
        <main className="mc-main">

          {/* ════════════════════════════════
              TAB: RESUMEN
          ════════════════════════════════ */}
          {tab === 'resumen' && (
            <div className="mc-section">
              <h2 className="mc-section__title">Bienvenida, <em>{usuario.nombre}</em></h2>

              <div className="mc-stats-grid">
                <div className="mc-stat-card mc-stat-card--verde" onClick={()=>setTab('descargas')}>
                  <div className="mc-stat-card__icon"><IconDownload/></div>
                  <strong>Mis descargas</strong>
                  <span>Recursos gratuitos</span>
                  <div className="mc-stat-card__arrow"><IconArrow/></div>
                </div>
                <div className="mc-stat-card mc-stat-card--azul" onClick={()=>setTab('recursos')}>
                  <div className="mc-stat-card__icon"><IconBox/></div>
                  <strong>Mis recursos</strong>
                  <span>Materiales comprados</span>
                  <div className="mc-stat-card__arrow"><IconArrow/></div>
                </div>
                <div className="mc-stat-card" onClick={()=>setTab('compras')}>
                  <div className="mc-stat-card__icon mc-stat-card__icon--azul"><IconCart/></div>
                  <strong>Mis compras</strong>
                  <span>Historial de pedidos</span>
                  <div className="mc-stat-card__arrow"><IconArrow/></div>
                </div>
                <div className="mc-stat-card" onClick={()=>setTab('puntos')}>
                  <div className="mc-stat-card__icon mc-stat-card__icon--amarillo"><IconStar/></div>
                  <strong>Mis puntos</strong>
                  <span>Beneficios y canjes</span>
                  <div className="mc-stat-card__arrow"><IconArrow/></div>
                </div>
                <div className="mc-stat-card" onClick={()=>setTab('formaciones')}>
                  <div className="mc-stat-card__icon mc-stat-card__icon--rosa"><IconBook/></div>
                  <strong>Formaciones</strong>
                  <span>Cursos inscritos</span>
                  <div className="mc-stat-card__arrow"><IconArrow/></div>
                </div>
              </div>

              {/* Acceso rápido Aula */}
              <div className="mc-aula-card">
                <div className="mc-aula-card__left">
                  <div className="mc-aula-card__icon"><IconAula/></div>
                  <div>
                    <strong>Aula Virtual</strong>
                    <p>Accede a tus cursos activos y materiales en Moodle</p>
                  </div>
                </div>
                <a href={AULA_URL} target="_blank" rel="noopener noreferrer" className="mc-aula-card__btn">
                  Ir al Aula <IconArrow/>
                </a>
              </div>
            </div>
          )}

          {/* ════════════════════════════════
              TAB: DESCARGAS
          ════════════════════════════════ */}
          {tab === 'descargas' && (
            <div className="mc-section">
              <h2 className="mc-section__title">Mis descargas</h2>
              {loadingTab ? (
                <div className="mc-loading"><IconSpinner/> Cargando…</div>
              ) : descargas.length === 0 ? (
                <div className="mc-empty">
                  <p>Aún no has descargado ningún recurso gratuito.</p>
                  <Link to="/recursos#gratuitos" className="mc-empty__btn">Ver recursos gratuitos</Link>
                </div>
              ) : (
                <div className="mc-lista">
                  {descargas.map((d,i) => (
                    <div className="mc-item" key={i}>
                      <div className="mc-item__icon mc-item__icon--verde"><IconDownload/></div>
                      <div className="mc-item__info">
                        <strong>{d.titulo}</strong>
                        <span>{d.tipo} · {d.categoria} · Descargado el {d.fecha_descarga}</span>
                      </div>
                      {d.archivo_url && (
                        <a href={d.archivo_url} target="_blank" rel="noopener noreferrer" className="mc-item__btn">
                          Descargar <IconArrow/>
                        </a>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* ════════════════════════════════
              TAB: MIS RECURSOS (paga)
          ════════════════════════════════ */}
          {tab === 'recursos' && (
            <div className="mc-section">
              <h2 className="mc-section__title">Mis recursos</h2>
              <p className="mc-section__sub">Materiales adquiridos. Disponibles de por vida.</p>

              {loadingTab ? (
                <div className="mc-loading"><IconSpinner/> Cargando…</div>
              ) : misRecursos.length === 0 ? (
                <div className="mc-empty">
                  <p style={{fontSize:'2rem',marginBottom:'.5rem'}}>📦</p>
                  <p>Aún no tienes recursos adquiridos.</p>
                  <p style={{fontSize:'.8rem',color:'#5a6a63',marginTop:'.3rem',maxWidth:320,textAlign:'center'}}>
                    Cuando realices una compra y sea validada, tus recursos aparecerán aquí.
                  </p>
                  <Link to="/recursos" className="mc-empty__btn">Ver catálogo de recursos</Link>
                </div>
              ) : (
                <div className="mc-recursos-grid">
                  {misRecursos.map((r,i) => {
                    const tipoIcon  = TIPO_ICON[r.tipo_material] || '📎';
                    const esArchivo = r.tipo_acceso === 'archivo' && r.archivo_url;
                    const esLink    = r.tipo_acceso === 'link_externo' && r.link_externo;
                    return (
                      <div className="mc-recurso-card" key={i}>
                        <div className="mc-recurso-card__head">
                          <div className="mc-recurso-card__icon">{tipoIcon}</div>
                          <div className="mc-recurso-card__info">
                            <strong>{r.titulo}</strong>
                            {r.descripcion && (
                              <span>{r.descripcion.slice(0,80)}{r.descripcion.length>80?'…':''}</span>
                            )}
                          </div>
                        </div>
                        <div className="mc-recurso-card__meta">
                          {r.formato && (
                            <span className="mc-recurso-badge">{r.formato}</span>
                          )}
                          <span className="mc-recurso-badge mc-recurso-badge--fecha">
                            Adquirido: {r.fecha_compra ? new Date(r.fecha_compra).toLocaleDateString('es-PE') : '—'}
                          </span>
                          {r.pedido_codigo && (
                            <span className="mc-recurso-badge mc-recurso-badge--codigo">{r.pedido_codigo}</span>
                          )}
                        </div>
                        <div className="mc-recurso-card__footer">
                        {esArchivo && (
                          <button
                            onClick={() => descargarRecurso(r.id, r.titulo)}
                            disabled={descargando[r.id]}
                            className="mc-recurso-btn mc-recurso-btn--dl"
                          >
                            {descargando[r.id]
                              ? <><IconSpinner/> Generando…</>
                              : <><IconDownload/> Descargar</>
                            }
                          </button>
                        )}
                          {esLink && (
                            <a href={r.link_externo} target="_blank" rel="noopener noreferrer" className="mc-recurso-btn mc-recurso-btn--link">
                              <IconLink/> Acceder
                            </a>
                          )}
                          {!esArchivo && !esLink && (
                            <span className="mc-recurso-btn mc-recurso-btn--pending">
                              Pendiente de activación
                            </span>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}

          {/* ════════════════════════════════
              TAB: COMPRAS
          ════════════════════════════════ */}
         {tab === 'compras' && (
  <div className="mc-section">
    <h2 className="mc-section__title">Mis compras</h2>
    <p className="mc-section__sub">Historial de todos tus pedidos.</p>

    {loadingTab ? (
      <div className="mc-loading"><IconSpinner/> Cargando…</div>
    ) : compras.length === 0 ? (
      <div className="mc-empty">
        <p style={{fontSize:'2rem',marginBottom:'.5rem'}}>🛍️</p>
        <p>Aún no tienes compras registradas.</p>
        <Link to="/recursos" className="mc-empty__btn">Ver recursos</Link>
      </div>
    ) : (
      <div className="mc-lista">
        {compras.map((c, i) => {
          const ESTADO_STYLE = {
            validado:        { bg:'#d1fae5', color:'#065f46', label:'Validado ✓'      },
            voucher_enviado: { bg:'#dbeafe', color:'#1d4ed8', label:'Voucher enviado' },
            pendiente:       { bg:'#fef3c7', color:'#92400e', label:'Pendiente'       },
            rechazado:       { bg:'#fee2e2', color:'#c53030', label:'Rechazado'       },
            reembolsado:     { bg:'#ede9fe', color:'#5b21b6', label:'Reembolsado'     },
          };
          const est = ESTADO_STYLE[c.estado] || ESTADO_STYLE.pendiente;
          return (
            <div className="mc-item" key={i}>
              <div className={`mc-item__icon mc-item__icon--${c.estado==='validado'?'verde':'amarillo'}`}>
                <IconCart/>
              </div>
              <div className="mc-item__info">
                <strong>{c.recurso_titulo}</strong>
                <span>
                  {c.codigo}
                  {c.metodo_pago ? ` · ${c.metodo_pago}` : ''}
                  {' · '}{new Date(c.created_at).toLocaleDateString('es-PE')}
                </span>
                {c.puntos_usados > 0 && (
                  <span style={{color:'#4db88a',fontSize:'.75rem'}}>
                    ⭐ {c.puntos_usados} pts canjeados (−S/. {c.descuento_puntos.toFixed(2)})
                  </span>
                )}
              </div>
             
             
              <div className="mc-item__right">
                <span className="mc-precio">S/. {c.monto.toFixed(2)}</span>
                <span className="mc-estado-badge" style={{background:est.bg, color:est.color}}>
                  {est.label}
                </span>
                {c.estado === 'validado' && (
                  <button
                    className="mc-recurso-btn mc-recurso-btn--dl"
                    style={{marginTop:'.4rem', fontSize:'.72rem', padding:'.4rem .8rem'}}
                    onClick={() => generarReciboCarrito({
                      pedido: { codigo: c.codigo },
                      items: [{ titulo: c.recurso_titulo, precio: c.monto }],
                      form: { nombre: usuario?.nombre + ' ' + (usuario?.apellido||''), email: usuario?.email },
                      metodo: c.metodo_pago,
                      descuento: c.descuento_puntos || 0,
                      cuponAplicado: c.descuento_puntos > 0 ? { codigo: 'PUNTOS' } : null,
                      totalFinal: c.monto,
                    })}
                  >
                    🧾 Descargar recibo
                  </button>
                )}
              </div>

            </div>
          );
        })}
      </div>
    )}
  </div>
)}

          {/* ════════════════════════════════
              TAB: PUNTOS
          ════════════════════════════════ */}
         {/* ════════════════════════════════
    TAB: PUNTOS
════════════════════════════════ */}
{tab === 'puntos' && (
  <div className="mc-section">
    <h2 className="mc-section__title">Mis puntos</h2>

    {loadingTab || !puntos ? (
      <div className="mc-loading"><IconSpinner/> Cargando…</div>
    ) : (
      <>
        {/* ── Hero saldo ── */}
        <div className="mc-puntos-hero">
          <div className="mc-puntos-hero__main">
            <div className="mc-puntos-hero__saldo">
              <strong>{puntos.puntos_disponibles.toLocaleString()}</strong>
              <span>puntos disponibles</span>
            </div>
            <div className={`mc-puntos-hero__nivel mc-nivel--${NIVEL_COLORS[puntos.nivel]||'gris'}`}>
              <IconShield/>
              <span>{NIVEL_LABELS[puntos.nivel] || 'Explorador'}</span>
            </div>
          </div>

          {/* Stats secundarios */}
          <div className="mc-puntos-stats">
            <div className="mc-puntos-stat">
              <span>Total acumulado</span>
              <strong>{puntos.puntos_totales.toLocaleString()} pts</strong>
            </div>
            <div className="mc-puntos-stat">
              <span>Canjeados</span>
              <strong>{puntos.puntos_canjeados.toLocaleString()} pts</strong>
            </div>
            <div className="mc-puntos-stat mc-puntos-stat--warn">
              <span>Por vencer</span>
              <strong>{puntos.por_vencer.toLocaleString()} pts</strong>
            </div>
          </div>

           {/* Equivalencia en soles */}
           <div className="mc-puntos-equiv">
            <IconStar/>
            <span>
              Tus puntos equivalen a{' '}
              <strong>S/. {(puntos.puntos_disponibles / 100).toFixed(2)}</strong>
              {' '}de descuento en tu próxima compra
            </span>
          </div>

          <p style={{fontSize:'.75rem', color:'#5a6a63', margin:'.5rem 0 0', lineHeight:1.5}}>
            <em>Nota: todos los puntos acumulados tienen vigencia de un año.</em>
          </p>

          {/* Alerta por vencer */}
          {puntos.por_vencer > 0 && (
            <div className="mc-puntos-alerta">
              ⚠️ Tienes <strong>{puntos.por_vencer} puntos</strong> que vencen en los próximos 30 días. ¡Úsalos antes de que expiren!
            </div>
          )}
        </div>

        {/* ── Cómo funciona ── */}
        <div className="mc-puntos-reglas">
          <h3 className="mc-subtitle">¿Cómo funcionan los puntos?</h3>
          <div className="mc-puntos-reglas__grid">
            <div className="mc-puntos-regla">
              <span className="mc-puntos-regla__icon">🛍️</span>
              <strong>Gana puntos</strong>
              <p>Por cada S/. 1 pagado en recursos o cursos, ganas <strong>10 puntos</strong></p>
            </div>
            <div className="mc-puntos-regla">
              <span className="mc-puntos-regla__icon">💰</span>
              <strong>Canjea descuentos</strong>
              <p>Cada <strong>100 puntos = S/. 1</strong> de descuento en tu próxima compra</p>
            </div>
            <div className="mc-puntos-regla">
              <span className="mc-puntos-regla__icon">⏰</span>
              <strong>Vencimiento</strong>
              <p>Los puntos vencen a los <strong>12 meses</strong> de ser acumulados</p>
            </div>
            <div className="mc-puntos-regla">
              <span className="mc-puntos-regla__icon">💎</span>
              <strong>Mínimo de canje</strong>
              <p>Puedes canjear desde <strong>500 puntos</strong> (= S/. 5 de descuento)</p>
            </div>
          </div>
        </div>

        {/* ── Historial ── */}
        <h3 className="mc-subtitle">Historial de movimientos</h3>
        {puntos.historial.length === 0 ? (
          <div className="mc-empty">
            <p>Aún no tienes movimientos de puntos.</p>
            <p style={{fontSize:'.8rem',color:'#5a6a63',marginTop:'.3rem'}}>
              Realiza tu primera compra para empezar a acumular.
            </p>
            <Link to="/recursos" className="mc-empty__btn">Ver recursos</Link>
          </div>
        ) : (
          <div className="mc-lista">
            {puntos.historial.map((h, i) => (
              <div className="mc-item" key={i}>
                <div className={`mc-item__icon mc-item__icon--${h.tipo==='ganado'?'verde':h.tipo==='canjeado'?'amarillo':'gris'}`}>
                  <IconStar/>
                </div>
                <div className="mc-item__info">
                  <strong>{h.motivo}</strong>
                  <span>
                    {new Date(h.created_at).toLocaleDateString('es-PE')}
                    {h.fecha_vencimiento ? ` · Vence: ${h.fecha_vencimiento}` : ''}
                    {h.referencia_id ? ` · Ref: #${h.referencia_id}` : ''}
                  </span>
                </div>
                <span className={`mc-pts-badge mc-pts-badge--${h.tipo}`}>
                  {h.tipo==='ganado'?'+':''}{h.puntos} pts
                </span>
              </div>
            ))}
          </div>
        )}
      </>
    )}
  </div>
)}

          {/* ════════════════════════════════
              TAB: FORMACIONES
          ════════════════════════════════ */}
          {tab === 'formaciones' && (
            <div className="mc-section">
              <h2 className="mc-section__title">Mis formaciones</h2>
              {loadingTab ? (
                <div className="mc-loading"><IconSpinner/> Cargando…</div>
              ) : formaciones.length === 0 ? (
                <div className="mc-empty">
                  <p>Aún no estás inscrita en ninguna formación.</p>
                  <Link to="/formaciones" className="mc-empty__btn">Ver formaciones</Link>
                </div>
              ) : (
                <div className="mc-lista">
                  {formaciones.map((f,i) => (
                    <div className="mc-item" key={i}>
                      <div className="mc-item__icon mc-item__icon--azul"><IconBook/></div>
                      <div className="mc-item__info">
                        <strong>{f.titulo}</strong>
                        <span>{f.codigo} · Inscrita el {f.fecha_inscripcion}</span>
                      </div>
                      <a href={AULA_URL} target="_blank" rel="noopener noreferrer" className="mc-item__btn">
                        Ir al Aula <IconArrow/>
                      </a>
                    </div>
                  ))}
                </div>
              )}
              <div className="mc-aula-card" style={{marginTop:'1.5rem'}}>
                <div className="mc-aula-card__left">
                  <div className="mc-aula-card__icon"><IconAula/></div>
                  <div>
                    <strong>Acceso directo al Aula Virtual</strong>
                    <p>Todos tus cursos, materiales y certificados</p>
                  </div>
                </div>
                <a href={AULA_URL} target="_blank" rel="noopener noreferrer" className="mc-aula-card__btn">
                  Abrir Aula <IconArrow/>
                </a>
              </div>
            </div>
          )}

          {/* ════════════════════════════════
              TAB: PERFIL
          ════════════════════════════════ */}
          {tab === 'perfil' && (
            <div className="mc-section">
              <h2 className="mc-section__title">Mi perfil</h2>
              {editError && <div className="mc-edit-error">{editError}</div>}
              <form className="mc-edit-form" onSubmit={guardarPerfil}>
                <div className="mc-edit-grid">
                  {[
                    { label:'Nombre',   key:'nombre',   type:'text',  placeholder:'Tu nombre'    },
                    { label:'Apellido', key:'apellido', type:'text',  placeholder:'Tu apellido'  },
                    { label:'Teléfono', key:'telefono', type:'tel',   placeholder:'+51 999 000 111' },
                    { label:'WhatsApp', key:'whatsapp', type:'tel',   placeholder:'+51 999 000 111' },
                  ].map(({label,key,type,placeholder}) => (
                    <div className="mc-edit-field" key={key}>
                      <label>{label}</label>
                      <input type={type} placeholder={placeholder}
                        value={editForm[key]||''}
                        onChange={e=>setEditForm(f=>({...f,[key]:e.target.value}))}
                      />
                    </div>
                  ))}

                  <div className="mc-edit-field mc-edit-field--full">
                    <label>Email</label>
                    <input type="email" value={usuario.email} disabled className="mc-input--disabled"/>
                    <span className="mc-input__hint">El email no se puede cambiar</span>
                  </div>

                  <div className="mc-edit-field mc-edit-field--full">
                    <label>Soy…</label>
                    <div className="mc-perfil-tabs">
                      {[
                        {val:'profesional', label:'Profesional'},
                        {val:'familia',     label:'Familia'},
                        {val:'estudiante',  label:'Estudiante'},
                        {val:'otro',        label:'Otro'},
                      ].map(({val,label})=>(
                        <button key={val} type="button"
                          className={`mc-perfil-tab ${editForm.perfil===val?'mc-perfil-tab--active':''}`}
                          onClick={()=>setEditForm(f=>({...f,perfil:val}))}
                        >{label}</button>
                      ))}
                    </div>
                  </div>

                  <label className="mc-edit-field mc-edit-field--full mc-checkbox">
                    <input type="checkbox"
                      checked={!!editForm.acepta_whatsapp}
                      onChange={e=>setEditForm(f=>({...f,acepta_whatsapp:e.target.checked}))}
                    />
                    <span>Acepto recibir novedades por WhatsApp</span>
                  </label>
                </div>

                <div className="mc-edit-actions">
                  <button type="submit" className="mc-btn-save" disabled={guardando}>
                    {guardando
                      ? <><IconSpinner/> Guardando…</>
                      : guardadoOk
                      ? <><IconCheck/> Guardado</>
                      : 'Guardar cambios'}
                  </button>
                </div>
              </form>

              {/* Cambiar contraseña */}
              <div className="mc-section__divider"/>
              <CambiarPassword authHeader={authHeader} showToast={showToast}/>

              {/* Zona cerrar sesión */}
              <div className="mc-section__divider"/>
              <div className="mc-logout-zone">
                <div>
                  <strong>Cerrar sesión</strong>
                  <p>Saldrás de tu cuenta y volverás a la página de inicio.</p>
                </div>
                <button className="mc-btn-logout-red" onClick={handleLogout}>
                  <IconLogout/> Cerrar sesión
                </button>
              </div>

            </div>
          )}

        
        

</main>
      </div>

      {/* ── Modal archivos múltiples ── */}
      {archivosModal && (
        <div className="mc-overlay" onClick={() => setArchivosModal(null)}>
          <div className="mc-modal" onClick={e => e.stopPropagation()}>
            <div className="mc-modal__head">
              <div>
                <h3>Archivos del recurso</h3>
                <p style={{fontSize:'.82rem',color:'#5a6a63',marginTop:'.2rem'}}>{archivosModal.titulo}</p>
              </div>
              <button className="mc-modal__close" onClick={() => setArchivosModal(null)}>
                <svg viewBox="0 0 24 24" fill="none" width="18" height="18"><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>
              </button>
            </div>
            <div className="mc-modal__body">
              <p className="mc-modal__hint">Haz clic en cada archivo para descargarlo.</p>
              <div className="mc-modal__archivos">
                {archivosModal.archivos.map((a, i) => (
                  <a key={i} href={a.url} target="_blank" rel="noopener noreferrer" className="mc-modal__archivo">
                    <div className="mc-modal__archivo-icon"><IconPdf/></div>
                    <div className="mc-modal__archivo-info">
                      <strong>{a.nombre}</strong>
                      {a.tamano_kb > 0 && <span>{a.tamano_kb} KB</span>}
                    </div>
                    <div className="mc-modal__archivo-dl"><IconDownload/></div>
                  </a>
                ))}
              </div>
            </div>
            <div className="mc-modal__foot">
              <button className="mc-btn-save" onClick={() => setArchivosModal(null)}>Cerrar</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

/* ════════════════════════════════════════
   Sub-componente: Cambiar contraseña
════════════════════════════════════════ */
function CambiarPassword({ authHeader, showToast }) {
  const API_LOCAL = 'https://centrocomunicar.com/api-comunicar/endpoints/auth.php';
  const [form,    setForm]   = useState({ password_actual:'', password_nueva:'', confirmacion:'' });
  const [error,   setError]  = useState('');
  const [cargando,setCarg]   = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    if (form.password_nueva !== form.confirmacion) { setError('Las contraseñas no coinciden'); return; }
    if (form.password_nueva.length < 6) { setError('Mínimo 6 caracteres'); return; }
    setCarg(true); setError('');
    try {
      const r = await fetch(`${API_LOCAL}?action=cambiar_pass`, {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(form),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      setForm({ password_actual:'', password_nueva:'', confirmacion:'' });
      showToast('Contraseña actualizada correctamente');
    } catch(err) { setError(err.message); }
    finally { setCarg(false); }
  };

  return (
    <div className="mc-change-pass">
      <h3>Cambiar contraseña</h3>
      {error && <div className="mc-edit-error">{error}</div>}
      <form onSubmit={handleSubmit} className="mc-edit-form">
        <div className="mc-edit-grid">
          {[
            { label:'Contraseña actual', key:'password_actual',  placeholder:'••••••' },
            { label:'Nueva contraseña',  key:'password_nueva',   placeholder:'Mínimo 6 caracteres' },
            { label:'Confirmar nueva',   key:'confirmacion',     placeholder:'Repite la nueva contraseña' },
          ].map(({label,key,placeholder})=>(
            <div className="mc-edit-field" key={key}>
              <label>{label}</label>
              <input type="password" placeholder={placeholder}
                value={form[key]}
                onChange={e=>setForm(f=>({...f,[key]:e.target.value}))}/>
            </div>
          ))}
        </div>
        <button type="submit" className="mc-btn-save" disabled={cargando}>
          {cargando ? <><IconSpinner/> Guardando…</> : 'Actualizar contraseña'}
        </button>
      </form>




    </div>


    
  );
}